import { usePageConfig } from '../PageConfigProvider/PageConfigProvider';
import { usePageState } from '../PageState/PageStateProvider';

export const useGetTabs = () => {
  const { config } = usePageConfig();

  return config.tabs;
};

export const useUpdateTab = () => {
  const { dispatch: pageStateDispatch } = usePageState();

  return (tabId: string) => {
    pageStateDispatch({ type: 'SET_ACTIVE_TAB', payload: tabId });
  };
};
